module.exports = __webpack_public_path__ + "img/default.278dae6a.png";